export interface AssistantActivityLike {
  goal?: string | null;
  action?: string | null;
  phase?: string | null;
  summary?: string | null;
  status?: string | null;
}

export interface AssistantActivityTextOptions {
  showGoal?: boolean;
}

export const ACTIVITY_TEXT_SEPARATOR = ' · ';

export function assistantActivityText(
  activity: AssistantActivityLike | null | undefined,
  options: AssistantActivityTextOptions = {}
): string | null {
  const action = normalizeText(activity?.action);
  if (action) {
    return activityTextWithGoal(activity?.goal, action, options);
  }
  const summary = normalizeText(activity?.summary);
  if (summary) {
    return activityTextWithGoal(activity?.goal, summary, options);
  }
  return null;
}

export function activityTextWithGoal(
  goal: string | null | undefined,
  text: string | null | undefined,
  options: AssistantActivityTextOptions = {}
): string | null {
  const normalizedText = normalizeText(text);
  const normalizedGoal = normalizeText(goal);
  const textPart = normalizedText;
  const goalPart =
    options.showGoal &&
    normalizedGoal &&
    normalizedGoal.toLowerCase() !== 'continue'
      ? normalizedGoal
      : null;

  if (!goalPart && !textPart) {
    return null;
  }
  return joinActivityTextParts([goalPart, textPart]);
}

export function joinActivityTextParts(
  parts: Array<string | null | undefined>
): string {
  return parts
    .map(part => normalizeText(part))
    .filter((part): part is string => part !== null)
    .join(ACTIVITY_TEXT_SEPARATOR);
}

function normalizeText(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : null;
}
